import { SVGProps } from 'react';

const PnlAnalyticsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    data-palette="PnlAnalyticsIcon">
    <path
      d="M5 10C2.2385 10 0 7.7615 0 5C0 2.761 1.4715 0.866 3.5 0.229V1.291C2.64046 1.64002 1.9289 2.27685 1.48703 3.09256C1.04516 3.90826 0.900441 4.85215 1.07763 5.76277C1.25481 6.67339 1.7429 7.49415 2.45838 8.08466C3.17387 8.67517 4.0723 8.99873 5 9C5.79689 8.99998 6.57563 8.76202 7.23642 8.31662C7.89722 7.87122 8.40998 7.23866 8.709 6.5H9.771C9.134 8.5285 7.239 10 5 10ZM9.975 5.5H4.5V0.025C4.6645 0.00849998 4.8315 0 5 0C7.7615 0 10 2.2385 10 5C10 5.1685 9.9915 5.3355 9.975 5.5ZM5.5 1.031V4.5H8.969C8.85771 3.6188 8.45643 2.79967 7.82838 2.17162C7.20033 1.54357 6.3812 1.14229 5.5 1.031Z"
      fill="var(--brand-bg-primary)"
    />
  </svg>
);

export default PnlAnalyticsIcon;
